import gql from 'graphql-tag'

export const FORGOT_PASSWORD_MUTATION = gql`
  mutation ForgotPassword($email: String!, $destination: String) {
    forgotPassword(email: $email, destination: $destination)
  }
`
